import React, { useEffect, useState } from "react";
import { imageDb } from "../../firebaseConfig";
import { getDownloadURL, listAll, ref, uploadBytes } from "firebase/storage";
import { v4 } from "uuid";

const GalleryImageUpload = () => {
  const [Img, setImg] = useState(null);
  const [imgUrl, setImgUrl] = useState([]);

  const handleClick = () => {
    if (Img !== null) {
      const imgRef = ref(imageDb, `galleryImages/${v4()}`);
      uploadBytes(imgRef, Img).then((value) => {
        console.log(value);
        getDownloadURL(value.ref).then((url) => {
          setImgUrl((prevUrls) => {
            if (!prevUrls.includes(url)) {
              return [...prevUrls, url];
            }
            return prevUrls;
          });
        });
      });
    }
  };

  useEffect(() => {
    listAll(ref(imageDb, "galleryImages")).then((imgs) => {
      console.log(imgs);
      imgs.items.forEach((val) => {
        getDownloadURL(val).then((url) => {
          setImgUrl((prevUrls) => {
            if (!prevUrls.includes(url)) {
              return [...prevUrls, url];
            }
            return prevUrls;
          });
        });
      });
    });
  }, []);

  return (
    <div>
      <input type="file" onChange={(e) => setImg(e.target.files[0])} />
      <button onClick={handleClick}>Upload</button>
      <br />

      {imgUrl.map((dataVal, index) => (
        <div key={index}>
          <img src={dataVal} alt="" width="200px" height="200px" />
        </div>
      ))}
    </div>
  );
};

export default GalleryImageUpload;
